import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SKIP_AUTH } from "./auth-context.token";
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private _http: HttpClient = inject(HttpClient);
  private BASE_URL: string = 'https://api.gipant.no/api/v1';
  // private BASE_URL: string = 'https://staging-api.gipant.no/api/v1';
  private _platformId = inject(PLATFORM_ID);

  private getToken(userType: 'team' | 'end-consumer'): string | null {
    if (!isPlatformBrowser(this._platformId)) return null;

    const userData: string | null = localStorage.getItem('user-' + userType);
    const parsedData = userData ? JSON.parse(userData) : '';
    return parsedData ? parsedData.tokens.access : null;
  }

  private createAuthHeaders(userType: 'team' | 'end-consumer', customHeaders?: HttpHeaders): HttpHeaders {
    const token: string | null = this.getToken(userType);
    let headers: HttpHeaders = customHeaders || new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  get<T>(endpoint: string, userType?: 'team' | 'end-consumer', skipAuth = false): Observable<T> {
    let context = new HttpContext();
    if (skipAuth) {
      context = context.set(SKIP_AUTH, true);
    }

    const options: {
      headers?: HttpHeaders;
      context?: HttpContext;
      observe?: 'body'; // optional for clarity, defaults to 'body'
      responseType?: 'json';
    } = {
      context
    };

    if (userType) {
      options.headers = this.createAuthHeaders(userType);
    }

    return this._http.get<T>(`${this.BASE_URL}${endpoint}`, options);
  }

  post<T>(endpoint: string, data: any, skipAuth = false): Observable<T> {
    let context = new HttpContext();
    if (skipAuth) {
      context = context.set(SKIP_AUTH, true);
    }

    const options: {
      context?: HttpContext;
      observe: 'body';
      responseType: 'json';
    } = {
      observe: 'body',
      responseType: 'json',
      context
    };

    return this._http.post<T>(`${this.BASE_URL}${endpoint}`, data, options);
  }



  patch<T>(endpoint: string, data: any, skipAuth = false): Observable<T> {
    let context = new HttpContext();
    if (skipAuth) {
      context = context.set(SKIP_AUTH, true);
    }

    const options: {
      context?: HttpContext;
      observe: 'body';
      responseType: 'json';
    } = {
      observe: 'body',
      responseType: 'json',
      context
    };

    return this._http.patch<T>(`${this.BASE_URL}${endpoint}`, data, options);
  }

}
